import { createContext, useContext, useState, useEffect } from "react";
import { cmsApi, TOKEN_KEY } from "../api";

const Ctx = createContext(null);
export const useWebsiteAdmin = () => useContext(Ctx);

export function WebsiteAdminAuthProvider({ children }) {
  const [admin, setAdmin] = useState(null);

  useEffect(() => {
    if (!localStorage.getItem(TOKEN_KEY)) { setAdmin(false); return; }
    cmsApi.get("/website-admin/auth/me")
      .then((r) => setAdmin(r.data))
      .catch(() => { localStorage.removeItem(TOKEN_KEY); setAdmin(false); });
  }, []);

  const login = async (email, password) => {
    const r = await cmsApi.post("/website-admin/auth/login", { email, password });
    localStorage.setItem(TOKEN_KEY, r.data.token);
    setAdmin(r.data.admin);
  };
  const logout = () => { localStorage.removeItem(TOKEN_KEY); setAdmin(false); };
  const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);

  return <Ctx.Provider value={{ admin, login, logout, setToken }}>{children}</Ctx.Provider>;
}
